document.addEventListener("DOMContentLoaded", function () {
  addFormListener();
  var contactFormStart = document.querySelector("#contact-form-start");
  contactFormStart?.addEventListener("submit", function (e) {
    e.preventDefault();
    var form = contactFormStart as HTMLFormElement;
    var formData = new FormData(form);

    const customInputs = contactFormStart?.querySelectorAll("ehm-forminput");
    var breakLoop = false;
    
    var errorsInForm = false;
    customInputs?.forEach((input) => {
      var shadowInput = input.shadowRoot?.querySelector("select");
      if (!breakLoop && shadowInput?.classList.contains("invalid")) {
        errorsInForm = true;
        shadowInput.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          (shadowInput as HTMLElement).focus();
        }, 1000);

        breakLoop = true;
        return;
      }
    });
    if (errorsInForm) {
      return;
    }
    var partial = document.querySelector("#partial-container");

    form!.querySelector(".loadingSpinner")?.classList.remove("hidden");
    form!.querySelector("button[type=submit]")?.setAttribute("disabled", "disabled");

    var actionUrl = form.getAttribute("action") ?? "";
    var object: any = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    var json = JSON.stringify(object);
    var newFormData = new FormData();
    newFormData.append("formData", json);
    let options: RequestInit = {
      method: "POST",
      body: newFormData,
    };
    fetch(actionUrl, options)
      .then((data) => data.text())
      .then((body) => {
        form.querySelector(".loadingSpinner")?.classList.add("hidden");
        form.querySelector("button[type=submit]")?.removeAttribute("disabled");
        partial!.innerHTML = body;
        window.scrollTo(0, 0);
        addFormListener();
        window.history.pushState(null, "", window.location.origin + window.location.pathname)
        addEventListener("popstate", function (event) {
          event.preventDefault();
          window.location.reload();
        });
      });
  });
});

const addFormListener = () => {
  var contactForm = document.querySelector("#fritids-form");
  contactForm?.addEventListener("submit", function (e) {
    e.preventDefault();
    var form = contactForm as HTMLFormElement;
    var formData = new FormData(form);
    var errorsInForm = false;
    const customInputs = contactForm?.querySelectorAll("ehm-forminput");
    var breakLoop = false;
    
    
    var fileElement: HTMLInputElement | undefined;
    customInputs?.forEach((input) => {
      if (input.shadowRoot?.querySelector("input#userfile")) {
        fileElement = input.shadowRoot?.querySelector(
          "input#userfile",
        ) as HTMLInputElement;
      }
      var shadowInput = input.shadowRoot?.querySelector("input, textarea");
      if (!breakLoop && shadowInput?.classList.contains("invalid")) {
        errorsInForm = true;
        shadowInput.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          (shadowInput as HTMLElement).focus();
        }, 1000);

        breakLoop = true;
        return;
      }
    });
    const requiredContainers = contactForm?.querySelectorAll(".required-form-section");
    requiredContainers?.forEach((container) => {
      if (container?.classList.contains("invalid")) {
        container?.classList.add("changed-invalid");
        container?.querySelector(".validationMessage")?.classList.remove("hidden");
        errorsInForm = true;
        if(!breakLoop){
          container.scrollIntoView({ behavior: "smooth" });
        }
        

        breakLoop = true;
        return;
      }
    })
    if (errorsInForm) {
      return;
    }
    var partial = document.querySelector("#partial-container");

    form!.querySelector(".loadingSpinner")?.classList.remove("hidden");
    form!.querySelector("button[type=submit]")?.setAttribute("disabled", "disabled");
    var file;
    if (fileElement && fileElement.value) {
      if (
        fileElement.dataset.validatefiletype &&
        !fileElement.value.endsWith(".png") &&
        !fileElement.value.endsWith(".jpg") &&
        !fileElement.value.endsWith(".jpeg") &&
        !fileElement.value.endsWith(".pdf")
      ) {
        fileElement.parentElement
          ?.querySelector(".validationMessage")
          ?.classList.remove("hidden");
        fileElement.focus();
        form.querySelector(".loadingSpinner")?.classList.add("hidden");
        form.querySelector("button[type=submit]")?.removeAttribute("disabled");
        return;
      }
      if (fileElement.files?.length) {
        file = fileElement.files![0];
      }
    }
    var actionUrl = form.getAttribute("action") ?? "";
    var object: any = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    var json = JSON.stringify(object);
    var newFormData = new FormData();
    newFormData.append("formData", json);
    if (file) {
      newFormData.append("file", file);
    }
    let options: RequestInit = {
      method: "POST",
      body: newFormData,
    };
    fetch(actionUrl, options)
      .then((data) => data.text())
      .then((body) => {
        form.querySelector(".loadingSpinner")?.classList.add("hidden");
        form.querySelector("button[type=submit]")?.removeAttribute("disabled");
        partial!.innerHTML = body;
        window.scrollTo(0, 0);
      });
  });
};
